


















































































































import CompanySheet from "@/components/company/CompanySheet.vue";
import MIconButton from "@/components/utility/mmmint/MIconButton.vue";
import MSelect from "@/components/utility/mmmint/MSelect.vue";
import MTextField from "@/components/utility/mmmint/MTextField.vue";
import { detailedDate } from "@/lib/utility/date-helper";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IReport } from "@/models/report.entity";
import { ITowingDetails } from "@/models/towing.entity";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    CompanySheet,
    MIconButton,
    MSelect,
    MTextField
  },
  filters: { detailedDate }
})
export default class PartnerReportTowingDetailCard extends PermissionMixin {
  @Prop({ required: true }) readonly towing!: ITowingDetails;
  @Prop({ required: true }) readonly report!: IReport;
  @Prop({ default: false, type: Boolean }) readonly hideCompanyDetails!: boolean;
}
